import * as React from 'react'

import { IconNameType, iconList } from '.'
import { SVGProps } from './svg'

export interface IconProps extends SVGProps {
  /**
   * Icon name
   */
  name?: IconNameType

  /**
   * Alternative way to pass icon to render if you want to render a custom component
   * or use `iconList` object lookup
   */
  as?: React.FC<SVGProps>
}

export function Icon({ name, as: asComponent, ...props }: IconProps) {
  const Component = name && iconList[name] ? iconList[name] : asComponent

  if (name && asComponent) {
    throw new Error('Specifying both "name" and "as" on Icon component is not supported')
  }

  if (!Component) {
    throw new Error('No icon to render!')
  }

  return <Component {...props} />
}
